import axios from "axios";
import { Api } from "../config/request";

export const getRideList = (payload) => {
    return Api.postRequest(`admins/rides`, payload);
};

export const getRideById = (rideId) => {
    return Api.getRequest(`admins/rides/${rideId}`);
};

export const uploadRideImage = (rideId, formData) => {
    return Api.multipartPostRequest(`rides/upload_image/${rideId}`, formData);
};

export const deleteRideImage = (rideId) => {
    return Api.deleteRequest(`rides/delete_image/${rideId}`);
};

export const getRideFeaturedImages = (rideId) => {
    return Api.getRequest(`rides/${rideId}/featured-images`);
};

export const presignRideFeaturedImages = (rideId, fileNames) => {
    return Api.postRequest(`rides/${rideId}/featured-images/presign`, { fileNames });
};

export const batchAddRideFeaturedImages = (rideId, images) => {
    return Api.postRequest(`rides/${rideId}/featured-images/batch`, { images });
};

export const deleteRideFeaturedImage = (rideId, imageId) => {
    return Api.deleteRequest(`rides/${rideId}/featured-images/${imageId}`);
};

export const replaceRideFeaturedImage = (rideId, imageId, url) => {
    return Api.putRequest(`rides/${rideId}/featured-images/${imageId}`, { url });
};

export const saveRideFeaturedImagesOrder = (rideId, featuredImages) => {
    return Api.putRequest(`rides/${rideId}/featured-images`, { featuredImages });
};

export const uploadFileViaApi = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await Api.multipartPostRequest("admins/files", formData);
    const data = unwrapRideApiData(response);
    const fileLink = data?.fileLink ?? response?.fileLink;
    if (!fileLink) {
        throw new Error("Image upload did not return a file link");
    }
    return fileLink;
};

export const uploadFileToPresignedUrl = async (presignedUrl, file, onProgress) => {
    await axios.put(presignedUrl, file, {
        headers: { "Content-Type": file.type },
        onUploadProgress: (event) => {
            if (onProgress && event.total) {
                onProgress(event.loaded / event.total);
            }
        },
    });
};

export const unwrapRideApiData = (response) => {
    if (!response) {
        return null;
    }
    if (response.statusCode === 200 && response.data !== undefined) {
        return response.data;
    }
    if (response.featuredImages !== undefined || response.imageURL !== undefined) {
        return response;
    }
    return response.data !== undefined ? response.data : response;
};

export const getApiErrorMessage = (error) =>
    error?.response?.data?.data?.message ||
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong";

const RideAPI = {
    getRideList,
    getRideById,
    uploadRideImage,
    deleteRideImage,
    getRideFeaturedImages,
    presignRideFeaturedImages,
    batchAddRideFeaturedImages,
    deleteRideFeaturedImage,
    replaceRideFeaturedImage,
    saveRideFeaturedImagesOrder,
    uploadFileViaApi,
    uploadFileToPresignedUrl,
    unwrapRideApiData,
    getApiErrorMessage,
};

export default RideAPI;
